import * as React from 'react';
import type { TransportRoute } from 'contracts/transport-routes';
import { apiGeneral, handleApiError } from 'services/api';

export const useDeleteTransportRoute = () => {
  const deleteTransportRoute = React.useCallback(
    async (id: string | number) => {
      try {
        const { data } = await apiGeneral.delete<TransportRoute>(
          `/general-route/${id}`
        );
        return data;
      } catch (e) {
        throw handleApiError(e);
      }
    },
    []
  );

  return {
    deleteTransportRoute,
  };
};
